import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { Account } from 'src/app/models/account.model';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { AuthService } from 'src/app/core/services/auth.service';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';
declare var fbq: Function;
declare var gtag: Function;
@Component({
  selector: 'app-order-insert-response',
  templateUrl: './order-insert-response.component.html',
  styleUrls: ['./order-insert-response.component.scss']
})
export class OrderInsertResponseComponent implements OnInit {
  operationNumber: string = '';
  totalAmount:number = 0;
  selectedAccount: Account;
  /*Suscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;
  fechaHoy = '';
  creditLineFNB: CreditLineFNB = new CreditLineFNB();

  constructor(@Inject(MAT_DIALOG_DATA) private input: any,
    private router: Router,
    private dialogRef: MatDialogRef<OrderInsertResponseComponent>,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private authService: AuthService) { 
      this.creditLineFNB = this.authService.getCreditLineFNB();
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.selectedAccount = account;
    })
    this.fechaHoy = this.datePipe.transform(new Date(), 'ddMMyyyy');
    this.authService.deleteShoppingCart();
  }

  ngOnInit() {
    this.operationNumber = this.input.operationNumber;
    fbq('track', 'Purchase', {value: this.totalAmount, currency: 'PEN'});
    gtag('event', 'conversion', { send_to: 'AW-11084559693/UG_bCIKvpIsYEM3qw6Up', value: this.totalAmount, currency: 'PEN'});
  }
  close() {
    this.router.navigate(['/ofivirtual/tienda/mis-pedidos']);
    this.dialogRef.close();
  }
}
